import type { Router, RouteRecordRaw } from 'vue-router'
import { ToastType } from '../Core/types/model/toast'

export const authRoutes: RouteRecordRaw = {
  path: '/login',
  name: 'login',

  component: () => import('./views/LoginView.vue'),
  meta: {
    requiresAuth: false,
    layout: 'Auth',
    showBackButton: false,
    title: 'words.dashboard',
    errorType: ToastType.Error,
  },
}

export default (router: Router) => {
  router.addRoute(authRoutes)
}
